import PrimaryContact from './PrimaryContact';

export default PrimaryContact;
